import axios from 'axios';
import { BOOST_DISCONNECTED } from '../config/boost-constants';

export default {
  namespaced: true,
  state: {
    connectionStatus: BOOST_DISCONNECTED,
    bootsURL: '',
  },
  mutations: {
    setConnectionStatus(state, payload) {
      state.connectionStatus = payload;
    },
    setBoostURL(state, url) {
      state.boostURL = url;
    },
  },
  getters: {
    connectionStatus(state) {
      return state.connectionStatus;
    },
  },
  actions: {
    async connect({ commit }) {
      try {
        const resp = await axios.post(`${process.env.VUE_APP_INTEGRATIONS}/boost/connect`);
        commit('setConnectionStatus', resp.data.status);
      } catch (error) {
        console.log(error);
      }
    },
    async getStarted(_, currentUser) {
      try {
        const { data } = await axios.post(`${process.env.VUE_APP_INTEGRATIONS}/boost/get-started`, {
          first_name: currentUser.first_name,
          last_name: currentUser.last_name,
          email: currentUser.email,
          phone: currentUser.phone,
        });
        return data;
      } catch (error) {
        console.log(error);
      }
    },
    async dashboard(_, currentUser) {
      try {
        const { data } = await axios.post(`${process.env.VUE_APP_INTEGRATIONS}/boost/dashboard`, {
          first_name: currentUser.first_name,
          last_name: currentUser.last_name,
          email: currentUser.email,
          phone: currentUser.phone,
        });
        return data;
      } catch (error) {
        console.log(error);
      }
    },
    async leadsPlusDashboard() {
      try {
        const { data } = await axios.post(
          `${process.env.VUE_APP_INTEGRATIONS}/boost/leadsplus-dashboard`,
        );
        return data;
      } catch (error) {
        console.log(error);
      }
    },
    async fetchBoostRedirectURL({ commit }, element) {
      try {
        const { data } = await axios.post(
          `${process.env.VUE_APP_INTEGRATIONS}/boost/embed/${element}`,
        );
        commit('setBoostURL', data.redirect_url);
      } catch (error) {
        console.log(error);
      }
    },
  },
};
